'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

// Note: we don't need types as the context is used only internally
var StateContext = React.createContext(null);
var Container =
/*#__PURE__*/
function () {
  function Container() {
    _classCallCheck(this, Container);

    this._listeners = [];
  }

  _createClass(Container, [{
    key: "setState",
    value: function setState(update, cb) {
      var _this = this;

      return Promise.resolve().then(function () {
        var nextState = typeof update === 'function' ? update(_this.state) : update; // Note: null/undefined how react behaves actually?
        // https://reactjs.org/docs/react-component.html doesn't tell much
        // https://blog.logrocket.com/returning-null-from-setstate-in-react-16-5fdb1c35d457/
        // if can be null (and undefined, lets be forgiving) if we opt-out from update in case of
        // update is function

        if (nextState == null) {
          if (cb) cb();
          return;
        } // Update state


        _this.state = Object.assign({}, _this.state, nextState);

        var promises = _this._listeners.map(function (listener) {
          return listener();
        });

        return Promise.all(promises).then(function () {
          if (cb) cb();
        });
      });
    }
  }, {
    key: "subscribe",
    value: function subscribe(fn) {
      this._listeners.push(fn);
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(fn) {
      this._listeners = this._listeners.filter(function (f) {
        return f !== fn;
      });
    }
  }]);

  return Container;
}();
function Provider(props) {
  /*
  How does it work:
   - first it reads a map from top-level Provider (if exists and it isn't the current one)
  - creates a map of instances for current Provider
  - if current Provider has inject, inject the instances by overriding the map
  - finally we create new unstated context provider, that can be used by hooks API useContainer
  */
  var inject = props.inject;
  return React__default.createElement(StateContext.Consumer, null, function (parentMap) {
    // NoteReview(simon): can we avoid to create new Map for each re-render of current Provider?
    var childMap = new Map(parentMap);

    if (inject) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = inject[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var inst = _step.value;
          childMap.set(inst.constructor, inst);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }

    return React__default.createElement(StateContext.Provider, {
      value: childMap
    }, props.children);
  });
}

function resolveInstance(containerItem, containerMap) {
  if (containerItem instanceof Container) {
    // its already existing instance
    return containerItem;
  }

  var instance = containerMap.get(containerItem);

  if (!instance) {
    // NoteReview: it would be nice to have some factory function to call intead of naively
    // instantiating without any parameters.
    // Also async/await would be great (needs react suspense)
    instance = new containerItem();
    containerMap.set(containerItem, instance);
  }

  return instance;
}

function useContainer(containerItem) {
  var map = React.useContext(StateContext);

  if (map === null) {
    throw new Error('unstated: You must wrap your app with a <Provider>');
  }

  var instanceRef = React.useRef(null);

  if (!instanceRef.current) {
    // $FlowFixMe
    instanceRef.current = resolveInstance(containerItem, map);
  }

  var instance = instanceRef.current;
  /*eslint no-unused-vars: ["error", { "varsIgnorePattern": "_" }]*/

  var _useState = React.useState(instance.state),
      _useState2 = _slicedToArray(_useState, 2),
      _state = _useState2[0],
      setState = _useState2[1];

  React.useEffect(function () {
    var isActive = true;

    function onUpdate() {
      if (isActive) {
        setState(instance.state);
      }
    }

    instance.subscribe(onUpdate);
    return function () {
      isActive = false;
      instance.unsubscribe(onUpdate);
    };
  }, []);
  return instance;
}

exports.Provider = Provider;
exports.Container = Container;
exports.useContainer = useContainer;
